import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteBeneficiaryInformation: Map<string, ConfirmationData> = new Map([
    ["e7486edd-7b28-403c-99b9-be59e155d046", { hidden: true }],
]);



